// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1N-0o","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__U9R5d"};